/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useStore from '../../store';
import { useDebounceEffect } from '../form/useDebounceEffect';

const QUERY_COUNT = gql`
	query {
		countUnreadAgentRegistration
	}
`;

const QUERY_RENEWAL_COUNT = gql`
	query {
		countInprogressAgentRenewal
	}
`;

function AgentRegistrationBadge() {
	const history = useHistory();
	const { t } = useTranslation();
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const [loadCount, { data: countData }] = useLazyQuery(QUERY_COUNT);
	const [loadRenewalCount, { data: countRenewalData }] = useLazyQuery(QUERY_RENEWAL_COUNT);

	useDebounceEffect(load, 200, [countUnreadNotifications]);

	function load() {
		loadCount();
		loadRenewalCount();
	}

	return (
		<>
			{parseInt(countData?.countUnreadAgentRegistration) > 0 && (
				<>
					<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
						{parseInt(countData?.countUnreadAgentRegistration)}
					</Badge>
				</>
			)}
			{parseInt(countRenewalData?.countInprogressAgentRenewal) > 0 && (
				<>
					<Badge
						zIndex="99"
						top="2px"
						right="2px"
						position="absolute"
						colorScheme="yellow"
						fontSize="16px"
						onClick={() => history.push('/agent-renewal')}
					>
						{parseInt(countRenewalData?.countInprogressAgentRenewal)} {t('Renew')}
					</Badge>
				</>
			)}
		</>
	);
}

export default AgentRegistrationBadge;
